/* INNOVATIVE v2 — scroll reveal (staggered fade-up), following apple.com (26-10).
   Apple's rule: the home page stays still; product pages animate every block as it comes into view.
   So: home, collections, blog, cart, search → no reveal. Product pages → every heading, paragraph,
   image and card in the product story rises in. Content pages (About, Showroom) → same as product.
   Safety: nothing is hidden unless this script runs, the browser supports IntersectionObserver and
   the visitor has not asked for reduced motion. Content already on screen is never hidden.
   Left alone: content inside accordions, and any story that already has its own scroll motion
   (e.g. Eva Vela's scroll-driven stage), detected after the page has fully loaded. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return; // keep the theme editor static

  var main = document.querySelector('main');
  var tpl = (main && main.getAttribute('data-template')) || '';
  if (!/^(product|page)(\.|$)/.test(tpl)) return; // like Apple: home and utility pages stay still

  var AROUND = [
    '.lo-section .lo-eyebrow', '.lo-section .lo-h2', '.lo-section .lo-lead',
    '.lo-section .lo-section-head .lo-link', '.lo-section .lo-actions',
    '.lo-card', '.lo-priv__card', '.lo-review', '.lo-promise', '.lo-faq__item',
    '.lo-guide', '.lo-split__media', '.lo-split__copy .lo-details',
    '.lo-video__frame', '.lo-trust__list li', '.lo-more__item', '.product-grid__item'
  ];
  var INSIDE = 'h2, h3, h4, p, li, img, picture, video, figure, iframe, table, blockquote';
  var ROOTS = '.lo-story, .page-content';
  var SKIP = '.lo-hero, .lo-topbar, header, .cart-drawer, dialog, .lo-legacy-story, product-info, .product-information, form';
  var OWN_MOTION_MARKERS = '[class*="scroll-reveal"], [class*="scroll-scrub"], [data-scroll], [data-aos]';

  var vh = window.innerHeight || 800;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });

  // A story with its own motion: marker classes, sticky (pinned) parts, or several real blocks
  // already faded out below the fold before anyone scrolls. Decorative SVG icons are ignored.
  function hasOwnMotion(root) {
    if (root.querySelector(OWN_MOTION_MARKERS)) return true;
    var n = 0, all = root.querySelectorAll('*');
    for (var i = 0; i < all.length && n <= 3; i++) {
      var el = all[i];
      if (el.closest('svg')) continue;
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky') return true;
      var r = el.getBoundingClientRect();
      if (r.top < vh || r.height < 24 || r.width < 60) continue;
      if (parseFloat(cs.opacity) < 0.5) n++;
    }
    return n > 3;
  }

  var skipRoots = [];
  function inSkipRoot(el) { for (var i = 0; i < skipRoots.length; i++) if (skipRoots[i].contains(el)) return true; return false; }

  function candidates() {
    var list = [], roots = document.querySelectorAll(ROOTS);
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (root.closest('details')) continue;
      if (root.__loChecked === undefined) { root.__loChecked = true; if (hasOwnMotion(root)) skipRoots.push(root); }
      if (inSkipRoot(root)) continue;
      var els = root.querySelectorAll(INSIDE);
      for (var i = 0; i < els.length; i++) list.push(els[i]);
    }
    var around = document.querySelectorAll(AROUND.join(','));
    for (var j = 0; j < around.length; j++) list.push(around[j]);
    return list;
  }

  function prep() {
    var els = candidates(), todo = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__loSeen) continue;               // each element is measured once, ever
      el.__loSeen = true;
      if (el.closest(SKIP) || inSkipRoot(el)) continue;
      if (el.parentElement && el.parentElement.closest('details')) continue; // accordion content
      if (el.closest('svg')) continue;
      todo.push(el);
    }
    // read all positions first, then write (no layout thrashing)
    var rects = todo.map(function (el) { return el.getBoundingClientRect(); });
    var groups = new Map();
    todo.forEach(function (el, i) {
      var r = rects[i];
      if (r.height < 12 || r.width < 12) return;   // hidden or tiny
      if (r.top < vh * 0.88) return;               // already visible: never hide it
      if (el.parentElement && el.parentElement.closest('[data-lo-reveal]')) return; // no nesting
      var parent = el.parentElement;
      var n = groups.get(parent) || 0;
      groups.set(parent, n + 1);
      el.style.setProperty('--lo-d', Math.min(n, 3) * 90 + 'ms'); // stagger siblings
      el.setAttribute('data-lo-reveal', '');
      io.observe(el);
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; vh = window.innerHeight || vh; prep(); }, 250);
  }

  document.documentElement.classList.add('lo-reveal-on');
  // Wait for the page (and any story scripts) to finish loading, so stories with their own motion are detected.
  function go() { requestAnimationFrame(function () { vh = window.innerHeight || vh; prep(); }); }
  if (document.readyState === 'complete') go(); else window.addEventListener('load', go);

  new MutationObserver(function (muts) {
    if (document.readyState !== 'complete') return;
    for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { schedule(); break; }
  }).observe(main || document.body, { childList: true, subtree: true });
})();
